import { api } from './api';
import { StaffPhotoStatus } from '../types/staff';

export interface StaffQueryParams {
    page?: number;
    limit?: number;
    search?: string;
    role?: string;
    status?: string;
    photoStatus?: StaffPhotoStatus;
}

// GET all staff members (paginated, filtered)
export const getStaffList = (params?: StaffQueryParams) =>
    api.get('/admin/staff', { params });

// GET full staff details
export const getStaffDetails = (id: number) =>
    api.get(`/admin/staff/${id}`);

// GET one level of a staff member's tree with per-person own + branch numbers
export const getStaffStats = (id: number) =>
    api.get(`/admin/staff/${id}/stats`);

// POST onboard new staff
export const createStaff = (data: any) =>
    api.post('/admin/staff', data);

// PATCH update existing staff (also used for activating/suspending)
export const updateStaff = (id: number, data: any) =>
    api.patch(`/admin/staff/${id}`, data);

// POST a photo (multipart `image`) — approved at once, replacing any photo waiting for review
export const uploadStaffPhoto = (id: number, image: Blob) => {
    const formData = new FormData();
    formData.append('image', image, 'staff-photo.jpg');
    return api.post(`/admin/staff/${id}/photo`, formData);
};

// POST approve / reject the photo waiting for review (reason: 3–200 chars)
export const approveStaffPhoto = (id: number) =>
    api.post(`/admin/staff/${id}/photo/approve`);

export const rejectStaffPhoto = (id: number, reason: string) =>
    api.post(`/admin/staff/${id}/photo/reject`, { reason });

// DELETE the approved photo
export const removeStaffPhoto = (id: number) =>
    api.delete(`/admin/staff/${id}/photo`);
